namespace GeniuzPOS.InitialData {
    export interface PsConnectEdcPortRow {
        Id?: number;
        ConnectEdcPort?: string;
        Remark?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsConnectEdcPortRow {
        export const idProperty = 'ConnectEdcPort';
        export const nameProperty = 'ConnectEdcPort';
        export const localTextPrefix = 'InitialData.PsConnectEdcPort';
        export const lookupKey = 'InitialData.PsConnectEdcPort';

        export function getLookup(): Q.Lookup<PsConnectEdcPortRow> {
            return Q.getLookup<PsConnectEdcPortRow>('InitialData.PsConnectEdcPort');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Modify';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Modify';

        export declare const enum Fields {
            Id = "Id",
            ConnectEdcPort = "ConnectEdcPort",
            Remark = "Remark",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
